import { render, staticRenderFns } from "./HonorIndex.vue?vue&type=template&id=165914aa&scoped=true"
import script from "./HonorIndex.vue?vue&type=script&lang=js"
export * from "./HonorIndex.vue?vue&type=script&lang=js"
import style0 from "./HonorIndex.vue?vue&type=style&index=0&id=165914aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165914aa",
  null
  
)

export default component.exports